import { ModalConfirmButton } from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import { useCqrsMedicalDataAccessAuthorizationUpdateCommand } from './MedicalDataAccessAuthorizationUpdateButton.hooks';

type MedicalDataAccessAuthorizationUpdateButtonProps = {
   readonly medicalInformationId: number;
   readonly onClose: VoidFunction;
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction | undefined;
};

export const MedicalDataAccessAuthorizationUpdateButton = (
   props: MedicalDataAccessAuthorizationUpdateButtonProps
): JSX.Element => {
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();
   const { executeAsync: updateMedicalDataAccessAuthorization } = useCqrsMedicalDataAccessAuthorizationUpdateCommand({
      onAuthenticationRequired: openAccountAuthorizationModal,
      onMedicalDataAccessAuthorizationUpdate: props.onMedicalDataAccessAuthorizationUpdate,
   });

   const handleClick = async (): Promise<void> => {
      await updateMedicalDataAccessAuthorization({
         medicalInformationId: props.medicalInformationId,
      });

      props.onClose();
   };

   return (
      <>
         <ModalConfirmButton label={patientMedicalInformationTranslationKeys.previewModal.sign} onClick={handleClick} />
         {renderAccountAuthorizationnModal({
            onAuthorization: handleClick,
         })}
      </>
   );
};
